'use client'

import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '../../utils/cn'

const inputVariants = cva(
  [
    'text-foreground file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground flex w-full min-w-0 rounded-lg border-[0.5px] px-3 text-xs transition-[color,background-color,border-color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
    'focus-visible:border-ring',
    'aria-invalid:not-focus:border-destructive-foreground',
    'data-[valid=true]:not-focus:border-success-foreground',
    '[*[aria-invalid="true"]_&]:not-focus:border-destructive-foreground',
    '[*[data-valid="true"]_&]:not-focus:border-success-foreground'
  ],
  {
    variants: {
      variant: {
        default: 'bg-input hover:bg-input/90',
        card: 'border-border bg-card hover:bg-card dark:bg-input dark:hover:bg-input'
      },
      size: {
        default: 'h-[45px] py-3',
        sm: 'h-[29px] py-1'
      }
    },
    defaultVariants: {
      variant: 'default',
      size: 'default'
    }
  }
)

type InputProps = Omit<React.ComponentProps<'input'>, 'size'> & VariantProps<typeof inputVariants>

function Input({ className, type, variant, size, ...props }: InputProps) {
  const disableAutoCompleteProps = {
    autoComplete: 'off',
    'data-lpignore': 'true', // lastpass
    'data-1p-ignore': 'true' // 1password
  }

  return (
    <input
      {...(type !== 'password' ? disableAutoCompleteProps : {})}
      type={type}
      data-slot="input"
      className={cn(inputVariants({ variant, size, className }))}
      {...props}
    />
  )
}

export { Input }
